import { convertHours } from './convertHours';
import { isDepartmentValid } from './isDepatmentValid';
import { hasValidHours } from './hasValidHours';

export const buildAllHours = (addResponse) => {
	const allHours = [{ Sales: convertHours(addResponse.hours) }];
	const { departments } = addResponse;

	departments.forEach((department) => {
		const { label } = department;
		let { hours } = department;
		if (!isDepartmentValid(department)) {
			return;
		}
		if (!hasValidHours(hours)) {
			hours = addResponse.hours;
		}

		allHours.push({ [label]: convertHours(hours) });
	});

	return allHours;
};
